<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        row-selection="single"
        class="agGrid"
        dom-layout="scroll"
        :auto-size-cell="true"
        @refresh="onRefresh"
        @selectionChanged="onRowSelectionChanged"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->
    <div class="button-containers mb-0">
      <button
        :disabled="!enableDelete"
        class="btn primary small outline"
        @click="deleteRoomSurcharge"
      >
        {{ $t('button.deleteSurcharge') }}
      </button>
      <button
        :disabled="!enableEdit"
        class="btn primary small"
        @click="fnOpenEditDialog"
      >
        {{ $t('button.modifySurcharge') }}
      </button>
      <button class="btn primary small" @click="fnOpenAddDialog">
        {{ $t('button.addSurcharge') }}
      </button>

      <!-- <button class="btn primary small outline">Sửa thuế</button> -->
    </div>

    <!-- START DIALOG -->
    <el-dialog
      :title="
        !isEditDialog
          ? $t('dialog.titleRoomSurchargeAdd')
          : $t('dialog.titleRoomSurchargeModify')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="body-overflow__visible"
      width="840px"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.code') }}
                  </div>
                  <validation-provider
                    :name="$t('field.code')"
                    rules="required|max:50|no_special"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formRoomSurcharge.code"
                        :readonly="isEditDialog"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.transactionCode') }}
                  </div>
                  <validation-provider
                    :name="$t('field.transactionCode')"
                    rules="required"
                  >
                    <div class="child-w-80">
                      <!-- <select
                        v-model="formRoomSurcharge.transaction_id"
                        @change="e => fnGetSubTransOptions(e.target.value)"
                      >
                        <option
                          v-for="option in transactionOptions"
                          :key="option.id"
                          :label="option.code"
                          :value="option.id"
                        />
                      </select> -->
                      <el-select
                        v-model="formRoomSurcharge.transaction_id"
                        placeholder=""
                        @change="onChangeTransaction"
                      >
                        <el-option
                          v-for="option in transactionOptions"
                          :key="option.id"
                          :label="option.code"
                          :value="option.id"
                        />
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.subTransactionCode') }}
                  </div>
                  <validation-provider
                    :name="$t('field.subTransactionCode')"
                    rules="required"
                  >
                    <div class="child-w-80">
                      <!-- <select v-model="formRoomSurcharge.sub_transaction_id">
                        <option
                          v-for="option in subTransactionOptions"
                          :key="option.id"
                          :label="option.code"
                          :value="option.id"
                        />
                      </select> -->
                      <el-select
                        v-model="formRoomSurcharge.sub_transaction_id"
                        placeholder=""
                      >
                        <el-option
                          v-for="option in subTransactionOptions"
                          :key="option.id"
                          :label="option.code"
                          :value="option.id"
                        />
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="das-form-row">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.amountOfMoney') }}
                  </div>
                  <validation-provider
                    :name="$t('field.amountOfMoney')"
                    rules="required|min_value:0|number"
                  >
                    <div class="child-w-80">
                      <!-- <input
                        v-model="formRoomSurcharge.money"
                        type="number"
                        min="0"
                        @keydown="
                          e => {
                            if (!e.key.match(/[0-9a-zA-Z]/g)) {
                              e.preventDefault()
                            }
                          }
                        "
                      /> -->
                      <VxCurrencyInput v-model="formRoomSurcharge.money" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('field.roomLevel') }}
                  </div>
                  <div class="child-w-80">
                    <!-- <select v-model="formRoomSurcharge.room_level_id">
                      <option
                        v-for="option in roomLevelOptions"
                        :key="option.id"
                        :label="option.code"
                        :value="option.id"
                      />
                    </select> -->

                    <el-select
                      v-model="formRoomSurcharge.room_level_id_list"
                      multiple
                      collapse-tags
                      placeholder=""
                    >
                      <el-option
                        v-for="option in roomLevelOptions"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4" style="align-self: end">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="is_active"
                      v-model="formRoomSurcharge.active"
                      type="checkbox"
                    />
                    <label for="is_active">{{ $t('field.active') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <validation-provider rules="max:200" :name="$t('field.desc')">
                    <div class="label">{{ $t('field.desc') }}</div>
                    <textarea
                      v-model="formRoomSurcharge.description"
                      style="width: 100%"
                      rows="3"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updateRoomSurcharge"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addRoomSurcharge">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <!-- END DIALOG -->
  </div>
</template>

<script>
/* eslint-disable */
import {
  getRoomSurchargeDetailApi,
  getRoomSurchargeListApi,
  addRoomSurchargeApi,
  updateRoomSurchargeApi,
  deleteRoomSurchargeApi
} from '@/api/Service_Policy/roomSurcharge.js'
import { getAllRoomLevelApi } from '@/api/Room/roomLevel'
import {
  getTransactionListApi,
  getTransactionListSimpleApi
} from '@/api/Transaction/transaction.js'
import { getSubTransactionListSimpleApi } from '@/api/Transaction/subTransaction.js'
import { Message } from 'element-ui'
import MultiCalendar from '@/components/ui/MultiCalendar.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'

export default {
  components: {
    MultiCalendar,
    CellRenderCheckboxReadonly,
    CalendarSelect
  },
  data() {
    return {
      loading: false,
      titlePopup: '',
      isEditDialog: false,

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      totalPage: 0,
      currentPage: 0,
      dialogFormVisible: false,
      searchParams: {
        // pageSize: 10,
        // pageNum: 1,
        // orderTp: "ASC",
      },
      formRoomSurcharge: {
        code: null,
        day_of_week: null,
        money: null,
        active: true,
        transaction_id: null,
        sub_transaction_id: null,
        date_from: null,
        date_to: null,
        room_level_id_list: [],
        description: null
      },
      columns: [
        // {
        //   headerName: "",
        //   field: "index",
        //   minWidth: 60,
        //   maxWidth: 60,
        //   checkboxSelection: true,
        //   resizable: false,
        // },
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          // maxWidth: 150,
          sortable: false
        },

        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'money',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'transaction_code',
          tooltipField: 'transaction_code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_transaction_code',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        },

        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 100,
          sortable: false
        },
        // {
        //   headerName: this.$t('grid.column.roomPairing'),
        //   minWidth: 130,
        //   maxWidth: 130,
        //   sortable: false

        //   // cellClass: "grid-cell-centered",
        // },
        // {
        //   headerName: this.$t('grid.column.billDetail'),
        //   // field: 'description',
        //   // cellClass: "grid-cell-centered",
        //   minWidth: 100,
        //   sortable: false
        // },
        // {
        //   headerName: this.$t('grid.column.detach'),
        //   // field: 'building_no',
        //   // cellClass: "grid-cell-centered",
        //   minWidth: 100,
        //   sortable: false
        // },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          tooltipField: 'description',
          // cellClass: "grid-cell-centered",
          minWidth: 250,
          sortable: false
        }
      ],
      rows: [],
      // Select options
      transactionOptions: [],
      subTransactionOptions: [],
      dayOfWeekOptions: [
        {
          value: 2,
          label: this.$t('variables.monday')
        },
        {
          value: 3,
          label: this.$t('variables.tuesday')
        },
        {
          value: 4,
          label: this.$t('variables.wednesday')
        },
        {
          value: 5,
          label: this.$t('variables.thursday')
        },
        {
          value: 6,
          label: this.$t('variables.friday')
        },
        {
          value: 7,
          label: this.$t('variables.saturday')
        },
        {
          value: 1,
          label: this.$t('variables.sunday')
        }
      ],
      roomLevelOptions: []
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (!val) {
        this.dialogFormVisible
          ? null
          : setTimeout(() => {
              this.resetRoomSurchargeDialog()
            }, 300)
      }
    }
  },

  mounted() {
    this.gridApi = this.$refs.agGrid.gridApi
    this.attachData()
    // GET SELECT OPTIONS
    this.fnGetTransactionOptions()
    this.fnGetRoomLevelOptions()
  },
  methods: {
    getFormRoomSurchargeDefault() {
      return {
        code: null,
        day_of_week: null,
        money: null,
        active: true,
        transaction_id: null,
        sub_transaction_id: null,
        date_from: null,
        date_to: null,
        room_level_id_list: [],
        description: null
      }
    },

    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getRoomSurchargeListApi(this.searchParams)
        this.loading = false
        this.rows = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
      // this.totalPage = Math.ceil(data.total / this.searchParams.pageSize);
      // this.currentPage = data.data.length == 0 ? 0 : data.page_num;
    },

    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.startTimeMustEarlierThanEndTime')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.formRoomSurcharge.date_from = date
      if (!this.checkValidDateRange(date, this.formRoomSurcharge.date_to)) {
        setTimeout(() => {
          this.formRoomSurcharge.date_to = null
        })
      }
    },

    onChangeDateTo(date) {
      this.formRoomSurcharge.date_to = date
      if (!this.checkValidDateRange(this.formRoomSurcharge.date_from, date)) {
        setTimeout(() => {
          this.formRoomSurcharge.date_to = null
        })
      }
    },

    fnValidate() {
      return true
    },

    resetRoomSurchargeDialog() {
      this.formRoomSurcharge = this.getFormRoomSurchargeDefault()
      this.subTransactionOptions = []
    },

    onRowSelectionChanged(rows) {
      this.enableEdit = rows?.length == 1
      this.enableDelete = !!rows.length
    },

    onClickAddSurcharge() {
      this.isEditDialog = false
      this.resetRoomSurchargeDialog()
    },
    onSubmit() {
      if (this.isEditDialog) this.updateRoomSurcharge()
      else this.addRoomSurcharge()
    },

    async addRoomSurcharge() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      addRoomSurchargeApi(this.formRoomSurcharge)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateRoomSurcharge() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      updateRoomSurchargeApi(this.formRoomSurcharge)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deleteRoomSurcharge() {
      const rowsSelected = this.gridApi.getSelectedRows()
      if (!rowsSelected?.length) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRoomSurcharge')
        })
      } else {
        const id_list = rowsSelected.map(item => item.id)
        this.$vxConfirm(this.$t('alert.deleteSurcharge'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deleteRoomSurchargeApi({
              id_list: id_list
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    async getRoomSurchargeDetail(id) {
      const data = await getRoomSurchargeDetailApi({ id })
      return data
    },

    // GET SELECT OPTIONS
    async fnGetTransactionOptions() {
      const resData = await getTransactionListSimpleApi({
        transactionGroup: 1
      })
      this.transactionOptions = [...resData.data]
    },

    async fnGetSubTransOptions(transactionId) {
      const resData = await getSubTransactionListSimpleApi({ transactionId })
      this.subTransactionOptions = [...resData.data]
    },

    async fnGetRoomLevelOptions() {
      const resData = await getAllRoomLevelApi()
      this.roomLevelOptions = [...resData.data]
    },

    onChangeTransaction(transactionId) {
      this.formRoomSurcharge.sub_transaction_id = null
      this.fnGetSubTransOptions(transactionId)
    },

    onChangeDate(dateFrom, dateTo) {
      // dateFrom = this.$moment(dateFrom).format('YYYY-MM-DD')
      // dateTo = this.$moment(dateTo).format('YYYY-MM-DD')
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.theStartDateMustBeEarlierOrTheSameAsTheEndDate'
          )
        })
        this.formRoomSurcharge.date_to = this.$moment(dateFrom)
          .add(1, 'd')
          .toDate()
      } else {
        this.formRoomSurcharge.date_to = dateTo
      }
      this.formRoomSurcharge.date_from = dateFrom
    },

    // DIALOG
    fnOpenAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
    },

    fnOpenEditDialog() {
      this.isEditDialog = true
      this.dialogFormVisible = true
      const rowSelected = this.gridApi.getSelectedRows()[0]
      this.fnGetSubTransOptions(rowSelected.transaction_id)
      this.formRoomSurcharge = { ...rowSelected }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-form-item {
  margin-bottom: 10px !important;

  .el-form-item {
    margin-bottom: 0px !important;
  }
}
</style>
